<template>
    <section>
        <div class="page">
            <div>
                <h2>Verifying your number</h2>
                <p>
                    ToTok requires an active phone number to create an account. If you are having problems, please check
                    the following:
                </p>
                <ul>
                    <li>
                        You have the latest version of ToTok installed from Google Play.
                    </li>
                    <li>You have entered your full international phone number, including the country code (or select
                        your country from the country list).
                    </li>
                    <ul>
                        <li>An example of a UAE phone number is: +971 527-879-xxx.</li>
                        <li>Please omit any leading zeros (0s) or exit codes from your number.
                        </li>
                    </ul>
                    <li>Your phone has full Internet access with strong signal. Try opening a web page to make sure.
                    </li>
                    <li>Your phone is not roaming.
                    </li>
                    <li>Your phone can receive international SMS messages.
                    </li>
                    <li>You are not using an unsupported device.</li>
                    <li>Your device is not jailbroken.
                    </li>
                </ul>
                <p>After you enter your phone number, please wait for an SMS to be delivered to your phone. The SMS will
                    contain a 6-digit verification code, which you can enter on the verification screen in ToTok. The
                    verification code is unique and changes each time you verify a new phone number or device. Please do
                    not guess the verification code; guessing too many times may delay your verification.
                </p>
                <p>If you do not receive your code via SMS, our automated system will resend your code. Please wait for
                    the 60-second time to finish counting down and do not edit your number during this time. Once the timer has completed, tap Resend.
                </p>
                <h6><i>Note: Depending on your carrier, you might receive charges for SMS.
                </i></h6>
                <p>If you have followed these steps and cannot receive a code, please do the following:
                </p>
                <ul>
                    <li>Delete ToTok from your phone.</li>
                    <li>Reboot your phone: turn your phone off, then turn it back on.
                    </li>
                    <li>Download the latest version of ToTok from Google Play.
                    </li>
                </ul>


            </div>
        </div>
    </section>
</template>
<script>
    export default {
        components: {},
        data() {
            return {};
        },
        computed: {},
        methods: {}
    }
</script>